import React from 'react';

import { GroupContext } from '../context';

export const useGroup = () => {
  const { getResolveName, levelPath, activityType } =
    React.useContext(GroupContext);

  return {
    getResolveName,
    levelPath,
    activityType,
  };
};
